'use client'

import { Button } from '@/components/ui/button'
import Image from 'next/image'

export function Header() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    element?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <header className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-md border-b border-muted">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl overflow-hidden shadow-lg">
            <Image
              src="/applogo-alarvia.png"
              alt="Alarvia logo"
              width={40}
              height={40}
              className="w-full h-full object-cover"
              priority
            />
          </div>
          <div>
            <span className="font-bold text-lg text-foreground block">Alarvia</span>
            <span className="text-xs text-secondary font-semibold">Android Exclusive</span>
          </div>
        </div>
        
        <nav className="hidden md:flex items-center gap-8">
          <button onClick={() => scrollToSection('features')} className="text-sm text-muted-foreground hover:text-foreground transition font-medium">Features</button>
          <button onClick={() => scrollToSection('benefits')} className="text-sm text-muted-foreground hover:text-foreground transition font-medium">Why Choose Us</button>
          <button onClick={() => scrollToSection('preregister')} className="text-sm text-muted-foreground hover:text-foreground transition font-medium">Pre-Register</button>
        </nav>

        <Button 
          onClick={() => scrollToSection('preregister')}
          className="bg-secondary hover:bg-secondary/90 text-foreground font-bold text-sm px-6"
        >
          Pre-Register
        </Button>
      </div>
    </header>
  )
}
